import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';
import { Product } from 'src/app/product.model'

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(private firestore: AngularFirestore) { }

  getProducts(category:string) {
    if(category=='HOME'){
      return this.firestore.collection('products', ref => ref.limit(4)).snapshotChanges();
    }else if(category=='NULL'){
      return this.firestore.collection('products').snapshotChanges();
    }else{
      return this.firestore.collection('products', ref => ref.where('category', 'array-contains', category)).snapshotChanges();
    }
  }

  getUID(): string{
    return localStorage.getItem("UID")||"";
  }

  setUID(UID: string){
    localStorage.setItem("UID", UID);
  }
}
